import { sameCalendarDate, toDateInput } from './dealLibraryDates';

/** Cent precision matches Deal Library amount inputs (`step="0.01"`).
 *  This only decides whether a total is part of the PATCH. Quick-adjust
 *  reconciliation stays in the backend (`_apply_quick_totals_adjustment_in_place`).
 */
function amountInputChanged(original, next) {
  const before = Number(original ?? 0);
  const after = Number(next);
  if (!Number.isFinite(before) || !Number.isFinite(after)) return true;
  return Math.round(before * 100) !== Math.round(after * 100);
}

/**
 * Deal Library inline PATCH.
 * `deal_value_chf` / `deal_cost_chf` are omitted unless that amount input
 * differs from the loaded totals, so a metadata save is not an explicit
 * quick-total edit.
 * Closure / service-rendered dates are omitted unless changed so a metadata
 * save does not re-assert dates (avoids accidental clears and closure-date
 * auth when only other fields change).
 */
export function buildDealLibraryPatch(originalDeal, editDraft, rejectionComment = null) {
  const valueNum = Number(editDraft.deal_value_chf);
  const costNum = Number(editDraft.deal_cost_chf);
  const patch = {
    project_name: editDraft.project_name,
    client_name: editDraft.client_name,
    stage: editDraft.stage,
    rejection_comment: rejectionComment,
    core_currency: editDraft.core_currency || 'CHF',
  };

  const nextClose = toDateInput(editDraft.deal_closure_date) || null;
  const nextService = toDateInput(editDraft.service_rendered_date) || null;
  if (!originalDeal || !sameCalendarDate(originalDeal.deal_closure_date, nextClose)) {
    patch.deal_closure_date = nextClose;
  }
  if (!originalDeal || !sameCalendarDate(originalDeal.service_rendered_date, nextService)) {
    patch.service_rendered_date = nextService;
  }

  if (!originalDeal || amountInputChanged(originalDeal.total_revenue_chf, valueNum)) {
    patch.deal_value_chf = valueNum;
  }
  if (!originalDeal || amountInputChanged(originalDeal.total_cost_chf, costNum)) {
    patch.deal_cost_chf = costNum;
  }
  return patch;
}
